<template>
  <div v-loading='onLoad'>
    <el-form :model="form" label-suffix=":" label-width="150px">
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="关键词库管理" prop="checkPass">
            <el-input type="textarea" :rows="10" placeholder="请输入内容(用英文逗号隔开)" v-model="form.keyWords">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    
    </el-form>
    <div style="text-align:center">
               <el-button  type="primary" icon="el-icon-circle-check" @click="saveRecord" size="small">
                保存
            </el-button>
     </div>
  </div>
</template>
<script>
  import {
  getKeywordDetail,submitKeyword
  } from "@/api/v4ward/v4system/keyword";
export default {
  data() {
    return {
      form: {
        keyWords: '',
      },
      onLoad:false

    };
  },
  created(){
    getKeywordDetail().then(res=>{
      this.form = res.data
      //  this.form.keyWords=this.form.keyWords.replace(',','，')
    })
  },
  methods:{
    saveRecord(){
      console.log(this.form.keyWords)
      this.form.keyWords=this.form.keyWords.replace(/，/g,',')
      console.log(this.form.keyWords)
      this.onLoad = true
      submitKeyword(this.form).then(res=>{
         this.$message.success("保存成功！")
         getKeywordDetail().then(res=>{
          this.form = res.data
          // this.form.keyWords=this.form.keyWords.replace(',','，')
          this.onLoad = false
        })
      })
    }
  }
};
</script>
<style scoped></style>
